import React, {useState, useEffect} from 'react'
import SettingShippingCarrierFilters from "./SettingShippingCarrierFilters"
import SettingShippingCarrierTable from "./SettingShippingCarrierTable"
import SettingShippingCarrierProvider from "./SettingShippingCarrierProvider"
import UseDebounce from "../helpers/UseDebounce";
import {getPlatform, getShippingRules} from "../../../services/api/apiSettingShippingRule"
import {Link} from "react-router-dom"
import CreateShippingCarrier from './CreateShippingCarrier';
import EditShippingCarrier from './data/EditShippingCarrier';
import { getShippingCarrier } from '../../../services/api/apiSettingShippingCarrier';

const SettingShippingCarrierPage = () => {
    const [optionsCarrier, _setOptionsCarrier] = useState([])
    const [optionsCombinationBox, _setOptionsCombinationBox] = useState([])
    const [optionsBoxName, _setOptionsBoxName] = useState([])
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(50)
    const [loading, _setLoading] = useState(true)
    const [total, _setTotal] = useState(0)
    const [error, _setError] = useState('')
    const [shippingCarrierLists, _setShippingCarrierLists] = useState([])
    const [filters, _setFilters] = useState({})
    const [openAddNew, _setOpenAddNew] = useState(false)

    const _hadleSetState = (filters) => {
        _setFilters(filters)
        _setPage(1)
    }

    const _fetchListOptionCarrier = async () => {
        try {
            const payload = {
                page: 1,
                limit: 500
            }
            const {data, success} = await getShippingCarrier(payload)
            
            if (!success) {
                return
            }

            const listSlugCarriers = data.shippingCarriers.map(item => item.slug).filter(item => !!item)
            const listShippingCarriers = data.shippingCarriers.map(item => item.name).filter(item => !!item)
            const listOriginalCarriers = data.shippingCarriers.map(item => item.original_carrier).filter(item => !!item)
            const listCarriers = [...listSlugCarriers,...listShippingCarriers,...listOriginalCarriers]
            const listCarriersFinal = []
            listCarriers.map(item => {
                if(!listCarriersFinal.includes(item)){
                    listCarriersFinal.push(item)
                }
            })

            const listOptions = listCarriersFinal.map(item => {
                return {
                    value: item,
                    name: item
                }
            })

            // const listShippingBox = data.shippingCarriers.map(item => item.box_name).filter(item => !!item)
            // const listShippingBoxFinal = []
            // listShippingBox.map(item => {
            //     if(!listShippingBoxFinal.includes(item)){
            //         listShippingBoxFinal.push(item)
            //     }
            // })

            // const listOptionsShippingBox = listShippingBoxFinal.map(item => {
            //     return {
            //         value: item,
            //         name: item
            //     }
            // })

            const listCombinationBox = data.shippingCarriers.map(item => item.combination_box).filter(item => !!item)
            const listCombinationBoxFinal = []
            listCombinationBox.map(item => {
                if(!listCombinationBoxFinal.includes(item)){
                    listCombinationBoxFinal.push(item)
                }
            })

            const listOptionsCombinationBox = listCombinationBoxFinal.map(item => {
                return {
                    value: item,
                    name: item
                }
            })

            const listShippingBox = data.shippingCarriers.map(item => item.shipping_box).flat().filter(item => !!item)
            const listBoxName = data.shippingCarriers.map(item => {
                if(item.box_type !== 'Combination box'){
                    return item.box_name
                }
            }).filter(item => !!item)
            const listShippingBoxName = [...listShippingBox,...listBoxName]
            const listBoxNameFinal = []
            listShippingBoxName.map(item => {
                if(!listBoxNameFinal.includes(item)){
                    listBoxNameFinal.push(item)
                }
            })

            const listOptionsBoxName = listBoxNameFinal.map(item => {
                return {
                    value: item,
                    name: item
                }
            }).sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            })
            
            _setOptionsCarrier(listOptions)
            _setOptionsCombinationBox(listOptionsCombinationBox)
            _setOptionsBoxName(listOptionsBoxName)
        } catch (e) {
            _setLoading(false)
            _setError(e.message)
        }
    }

    const _fetchListShippingCarrier = async () => {
        try {
            _setLoading(true)
            _setError('')
            
            const payload = {
                limit: limit,
                page: page
            }
            
            if(filters.carriers && filters.carriers.length > 0) payload.carriers = filters.carriers
            if(filters.box_names && filters.box_names.length > 0) payload.box_names = filters.box_names
            if(filters.combination_boxes && filters.combination_boxes.length > 0) payload.combination_boxes = filters.combination_boxes
            if(filters.original_carrier_status){
                if(filters.original_carrier_status === 'active'){
                    payload.status = 1
                }else{
                    payload.status = 0
                }
                 
            }
            if(filters.label_generation_status){
                if(filters.label_generation_status === 'active'){
                    payload.label_generation_status = 1
                }else{
                    payload.label_generation_status = 0
                }
            }

            if(filters.box_type){
                payload.box_type = filters.box_type
            }
            
            const {data, success, message} = await getShippingCarrier(payload)
            // const {data, success, message} = await getShippingRules(payload)

            if (!success) {
                _setLoading(false)
                _setShippingCarrierLists([])
                return _setError(message)
            }

            const {shippingCarriers, total} = data
            
            _setShippingCarrierLists(shippingCarriers)

            _setLoading(false)
            _setError('')
            _setTotal(total)
        } catch (e) {
            _setLoading(false)
            _setError(e.message)
        }
    }

    const _handleSetPage = (page) => {
        _setPage(page)
    }

    const _handleSetSize = (size) => {
        _setLimit(size)
    }

    useEffect(() => {
        _fetchListOptionCarrier()
    }, [shippingCarrierLists])

    useEffect(() => {
        _fetchListShippingCarrier()
    }, [filters.carriers, filters.box_names, filters.combination_boxes, filters.original_carrier_status, filters.label_generation_status, filters.box_type, limit, page]) // eslint-disable-line react-hooks/exhaustive-deps

    const toggleModalAddNew = () => _setOpenAddNew(!openAddNew)

    const _handleReloadPageEdit = () => {
        _fetchListShippingCarrier()
        .then(() => {
            _setFilters({})
        })
    }

    return (
        <SettingShippingCarrierProvider filters={filters} setState={_hadleSetState} loadShippingCarriers={_fetchListShippingCarrier} loadShippingCarriersEdit={_handleReloadPageEdit}>
            <div className="d-flex justify-content-between align-items-center">
                <h1 className="card-title">Shipping carrier management</h1>
                <Link className="linkDetail" to={`/setting-boxes`}><button className="btn btn-primary ml-3">Setting boxes</button></Link>
                {/* <div className="actions">
                            <button className="btn btn-primary" onClick={toggleModalAddNew}>Add new</button>
                            <CreateShippingCarrier
                                toggle={toggleModalAddNew}
                                modal={openAddNew}
                                // setModal={setModal}
                                // reload={_fetchListPriorityStore}
                                // listProductType={listProductType}
                                // err={err}
                                // listStore={listStore}
                            />
                </div> */}
            </div>
            <div className="card SettingShippingRulePage SettingShippingCarrierPage">
                <div className="card-body">
                    <div className="ShippingRuleFilters">
                        <SettingShippingCarrierFilters optionsCarrier={optionsCarrier} optionsCombinationBox={optionsCombinationBox} optionsBoxName={optionsBoxName}/>
                    </div>
                    <div>
                        {error && <div className="text-danger">{error}</div> }
                        <SettingShippingCarrierTable loading={loading} limit={limit} page={page} total={total} onChangeSize={_handleSetSize} onChangePage={_handleSetPage} shippingCarriers={shippingCarrierLists}/>
                    </div>
                </div>
            </div>
        </SettingShippingCarrierProvider>
    )
}

export default SettingShippingCarrierPage